<template>
<div id="contact">
   
    <div class= "container">
    
    <div id="contact" class="main middlediv">
      <h3 class="titlespace">Contact</h3>
      <p>Would you like me to help you with your Project or like me to create your website or 
          want to test your Website/Web App?<br>
          Or just want to Chat...?<br>
           Please contact using the form below! 
          <a><i class="fa fa-smile-o fa-2x"></i></a>
      </p>

      <form @submit.prevent="save">
        <div class="form-group">
        <input type="text" class="form-control" v-model="name" placeholder="Your name" required>
          <br>
        <input type="email"  v-model="email" class="form-control" placeholder="Your email" required>
       <br>
        <textarea name="message" class="form-control" v-model="message" placeholder="Your message" required></textarea>
       <br>
        
        <button type="submit" class="btn btn-primary">Send</button>
        </div>
      </form>
      
      
    </div>
   
 
  </div>
</div>
</template>

<script>
import db from './firebaseInit'
import firebaseInit from './firebaseInit';
export default {
  name: 'contact',
    data (){
        return {
            mid: null,
            name: null,
            email: null,
            message: null

        }
    },
    methods: {
      save(){
        db.collection('contact').add({
         
          name: this.name,
          email: this.email,
          message: this.message
        })
        .then(docRef => {
          alert(`Thank You For Contacting me, I will get back to you as soon as possible....!`);
          this.$router.go({path: this.$router.path});
          
        }).catch(error => console.log(err))
      }
    }
}
</script>


<style scoped>
  .centeredmessage {
  text-align: center;
  margin-bottom: 3%;
}

.leftmessage {
  text-align: right;
}

.values {
  padding-left: 10%;
}
.listparagraph {
  padding-right: 10%;
}
h2 {
  font-family: 'Overlock', cursive;
}
h3 {
  font-family: 'Overlock', cursive;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

h4 {
  font-family: 'Overlock', cursive;
}

p {
  font-family: 'Quicksand', sans-serif;
  text-align: justify;
  
}

.fa{
    color: rgb(58, 245, 41);
}

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue